import {useEffect} from "react";
import {postSubmit} from "@ui-seeker/utils";

import {WEBBACK_V2_API} from "@constants";
import {isLoadingCommonFilters, isSystemBusy} from "@signals";
import {
	isLoadingProductDetailsEvolution,
	isLoadingProductDetailsEvolutionTable,
	isLoadingSellerDetails,
	isLoadingSellerDetailsPage,
	isLoadingSellerProductsDetails,
	isSellerDetailsEmpty,
	sellerDetailsData,
	sellerProductDetailsData,
	productDetailsEvolutionsAllData,
	productDetailsEvolutionAllSellers,
	productDetailsEvolutionSelectedSku,
	productDetailsEvolutionSkuData,
	productDetailsEvolutionTableDates,
	productDetailsEvolutionTableAllData
} from "../@signals";
import {batch} from "@preact/signals-react";


export default function useMarketplacesSellerDetailsSearch() {

	useEffect(() => {
		if (!isLoadingSellerDetailsPage.value)
			isLoadingCommonFilters.value = false
	}, [isLoadingSellerDetailsPage.value]);

	const __callSellerDetails = values => {
		isLoadingSellerDetails.value = true
		postSubmit(`${WEBBACK_V2_API}/marketplaces/seller-details/context`, values).then(({ data }) => {
			sellerDetailsData.value = data
			if (!data || !data.length) {
				isSellerDetailsEmpty.value = true
				isLoadingCommonFilters.value = false
			}
		}).catch(() => isSystemBusy.value = true
		).finally(() => isLoadingSellerDetails.value = false)
	}

	const __callProductDetails = values => {
		isLoadingSellerProductsDetails.value = true
		postSubmit(`${WEBBACK_V2_API}/marketplaces/seller-details/product-details`, values).then(({ data }) => {
			sellerProductDetailsData.value = data
		}).catch(() => isSystemBusy.value = true
		).finally(() => isLoadingSellerProductsDetails.value = false)
	}

	const __callProductDetailsEvolution = values => {
		isLoadingProductDetailsEvolution.value = true
		postSubmit(`${WEBBACK_V2_API}/marketplaces/seller-details/product-evolution`, values).then(res => batch(() => {
			productDetailsEvolutionsAllData.value = res.data
			productDetailsEvolutionAllSellers.value = res.sellers
			productDetailsEvolutionSelectedSku.value = res.skuSelected
			productDetailsEvolutionSkuData.value = res.skusData
		})).finally(() => isLoadingProductDetailsEvolution.value = false)
	}

	const __callProductDetailsEvolutionTable = values => {
		isLoadingProductDetailsEvolutionTable.value = true
		postSubmit(`${WEBBACK_V2_API}/marketplaces/seller-details/product-evo-details`, values).then(res => batch(() => {
			productDetailsEvolutionTableDates.value = res.dates
			productDetailsEvolutionTableAllData.value = res.data
		})).finally(() => isLoadingProductDetailsEvolutionTable.value = false)
	}

	const handleSubmit = values => {
		isSystemBusy.value = false
		isSellerDetailsEmpty.value = false
		__callSellerDetails(values)
		__callProductDetails(values)
		__callProductDetailsEvolution(values)
		__callProductDetailsEvolutionTable(values)
	}

	return {
		handleSubmit
	}
}